import Cookies from "js-cookie"
import {  useDispatch, useSelector } from "react-redux"
import { Link, Navigate, useNavigate  } from "react-router-dom"
import { logOut } from "../redux/slices/adminSlice"
import { logOutA } from "../redux/slices/superAdminSlice"
import { deleteAllSensors } from "../redux/slices/allSensorSlice"
import { deleteAllCollectors } from "../redux/slices/collectorsSlice"
import { deleteAllComments } from "../redux/slices/commentsSlice"
import { logOutF } from "../redux/slices/farmsSlice"
import { logOutS } from "../redux/slices/singleFarmSlice"
import { deleteSensor } from "../redux/slices/singleSensorSlice"
import { logOutL } from "../redux/slices/listDamSlice"
import { logOutC } from "../redux/slices/singleCattleSlice"
import { deleteAllCol } from "../redux/slices/singleCollectorSlice"
import { deleteWarn } from "../redux/slices/warningSlice"





const PanelLayOutfirst=({children})=>{
    const {isLoginA}=useSelector(state=>state.p.adminA)
    const {isLogin}=useSelector(state=>state.p.admin)
    const dispatch=useDispatch()
    const navigate=useNavigate()
    const handleLogout=()=>{
        dispatch(logOut())
        dispatch(logOutA())
        dispatch(deleteAllSensors())
        dispatch(deleteAllCollectors())
        dispatch(deleteAllComments())
        dispatch(logOutF())
        dispatch(logOutS())
        dispatch(deleteSensor())
        dispatch(logOutL())
        
        dispatch(logOutC())
        dispatch(deleteAllCol())
        dispatch(deleteWarn())
        navigate('/')
    }

    if(!isLoginA&&!Cookies.get('AuthToken')||Cookies.get('AuthToken')===undefined){
        handleLogout()
        return <Navigate to={'/'}/>
    }
    else if(isLoginA&&Cookies.get('AuthToken')!==undefined){
        return <div className="panellLayout">
        {/* <NavBar />
        <SideBar/> */}
        <div  className="ChildrenCon">
        <div style={{width:'90%',margin:'50px auto'}}>{children}</div>
        </div>
        
        </div>
    }
}
export default PanelLayOutfirst